<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs" />
    <b-alert variant="danger" :show="hasError">{{errorMessage}}</b-alert>
    <b-row :style="containerStyle">
      <b-col lg="6">
        <br>
        <data-section v-if="workflow" ref="headerForm" :section="headerSection" :boldTintColor="workflow.bold_tint_color" v-on:submit="submitForms"></data-section>
        <br>
      </b-col>
      <b-col lg="6" v-if="selectedChoice">
        <br>
        <h4>
          {{selectedChoice.heading}}
        </h4>
        <data-section v-for="(section, index) in formSections" :section="section" :boldTintColor="workflow.bold_tint_color" :key="index" ref="forms" v-on:submit="submitForms"></data-section>
        <p class="mb-3" v-if="formSections != null && formSections.length > 0">
          <b-button variant="primary" class="ml-auto" v-on:click="submitForms">Submit</b-button>
        </p>
        <br>

      </b-col>

    </b-row>
  </b-container>
</template>

<script>
// import moment from 'moment'
import API from '@/lib/api'
import DataSection from '@/components/DataSection'
import ListItem from '@/components/ListItem'
import _ from 'lodash'

export default {
  name: 'NewEvent',
  components: { DataSection, ListItem },
  data () {
    var selectedTeamId = this.$route.query.selectedTeamId != null && this.$route.query.selectedTeamId !== '' ? parseInt(this.$route.query.selectedTeamId) : null
    var data = {
      tracker: {
        originatorTeamId: this.$route.query.otid != null && this.$route.query.otid !== '' ? parseInt(this.$route.query.otid) : null,
        workflowId: this.$route.query.wfid != null && this.$route.query.wfid !== '' ? parseInt(this.$route.query.wfid) : null,
        jobNumber: this.$route.query.job,
        trackerId: this.$route.query.tid != null && this.$route.query.tid !== '' ? parseInt(this.$route.query.tid) : null,
        originatorData: this.$route.query.odata
      },
      selectedChoiceId: this.$route.query.selectedChoiceId !== '' ? this.$route.query.selectedChoiceId : null,
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'New Event', to: this.$route.fullPath, active: true}],
      workflow: null,
      hasError: false,
      errorMessage: null,
      teams: this.$store.getters.teams
        .map((team) => { return {text: team.name, value: team} }),
      team: selectedTeamId != null
            ? this.$store.getters.teams.find((team) => { return team.id === selectedTeamId })
            : this.$store.state.currentTeam,
      headerSection: null,
      formSections: [],
      event: null
    }
    console.log('data')
    console.log(data)
    return data
  },
  watch: {
    '$route' (to, from) {
      this.fetchWorkflow()
    }
  },
  computed: {
    containerStyle () {
      var style = {}
      if (this.workflow != null) {
        style.backgroundColor = this.workflow.light_tint_color
      }
      return style
    },
    selectedChoice () {
      if (this.workflow != null && this.selectedChoiceId != null) {
        return this.findChoice(this.workflow.choices, this.selectedChoiceId)
      } else {
        return null
      }
    }
  },
  mounted () {
    this.fetchWorkflow()
  },
  methods: {
    fetchWorkflow () {
      this.hasError = false
      API.get(`/workflows/${this.tracker.workflowId}`, {}, this.$store.getters.authHeaders)
        .then((response) => {
          this.workflow = response.data
          this.updateHeaderSection()
          this.formSections = this.selectedChoice.data_sections
        })
    },
    findChoice (choices, choiceId) {
      var foundChoice = null
      if (choices != null) {
        choices.forEach((choice) => {
          if (foundChoice == null) {
            if (choice.id === choiceId) {
              foundChoice = choice
            } else {
              foundChoice = this.findChoice(choice.choices, choiceId)
            }
          }
        })
      }
      console.log('found choice')
      console.log(foundChoice)
      return foundChoice
    },
    updateTeam () {
      this.$store.commit('selectCurrentTeam', this.team)
    },
    updateHeaderSection () {
      var dataItems = []
      var dataEntryItems = []
      if (this.workflow != null) {
        dataItems.push({
          name: 'Workflow',
          type: 'string',
          value: this.workflow.name
        })
      }
      dataEntryItems.push({
        entry_type: 'string',
        field_name: 'job_number',
        prompt: this.terminology('job_number', 'Job Number'),
        mandatory: true,
        max_length: 20,
        value: this.tracker.jobNumber
      })
      dataEntryItems.push({
        entry_type: 'string',
        field_name: 'confirm_job_number',
        prompt: 'Confirm ' + this.terminology('job_number', 'Job Number'),
        mandatory: true,
        max_length: 20,
        value: this.tracker.jobNumber
      })
      this.headerSection = {
        heading: 'Tracker Details',
        image_url: this.workflow.image_url,
        data_items: dataItems,
        data_entry_items: dataEntryItems
      }
    },
    terminology (term, fallback) {
      const terms = this.workflow.text_terms
      if (terms != null && terms[term] != null) {
        return terms[term]
      } else {
        return fallback
      }
    },
    submitForms () {
      this.hasError = false
      var allForms = [this.$refs.headerForm]
      this.$refs.forms.forEach((form) => { allForms.push(form) })

      var isValid = true
      allForms.forEach((form) => { isValid = form.validate() && isValid })

      if (isValid) {
        var values = []
        allForms.forEach((form) => { values = _.concat(values, form.values()) })
        const params = {
          team_id: this.team.id,
          data_entry_values: values,
          tracker: {
            team_id: this.tracker.originatorTeamId,
            id: this.tracker.trackerId,
            job_number: this.tracker.jobNumber,
            originator_data: this.tracker.originatorData
          }
        }
        this.saving = true
        console.log(params)
        API.post(this.selectedChoice.submit_url, params, this.$store.getters.authHeaders).then((result) => {
          this.$router.push({path: '/submission_complete', query: { w: this.tracker.workflowId, a: this.selectedChoice.id }})
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            this.errorMessage = error.response.data.message
            this.hasError = true
          }
          this.saving = false
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/NewEvent.vue